@if (control && control!.invalid && (control!.dirty || control!.touched)) {
  <div class="invalid" dir="auto">
    @if (control?.errors?.required) {
      <small> {{ name }} {{ 'formErrors.is required.' | translate }} </small>
    }
    @if (control?.errors?.invalid) {
      <small> {{ name }} {{ 'formErrors.is invalid.' | translate }} </small>
    }
    @if (control?.errors?.minlength) {
      <small> {{ name }} {{ 'formErrors.is required to be at least' | translate }} {{ control?.errors?.minlength.requiredLength }} {{ 'character' | translate }}. </small>
    }
    @if (control?.errors?.maxlength) {
      <small> {{ name }} {{ 'formErrors.cannot be longer than' | translate }} {{ control?.errors?.maxlength.requiredLength }} {{ 'characters' | translate }}. </small>
    }
    @if (control?.errors?.pattern) {
      <small> {{ name + ' ' + (patternError | translate) }} </small>
    }
    @if (control?.errors?.max) {
      <small> {{ name }} {{ "formErrors.can't be greater than" | translate }} {{ control?.errors?.max.max }} </small>
    }
    @if (control?.errors?.maxNumber) {
      <small> {{ name }} {{ "formErrors.can't be greater than" | translate }} {{ control?.errors?.maxNumber?.refValues[1] }} </small>
    }
    @if (control?.errors?.min) {
      <small> {{ name }} {{ "formErrors.can't be less than" | translate }} {{ control?.errors?.min.min }} </small>
    }
    @if (control?.errors?.hasNumber) {
      <small> {{ name }} {{ 'formErrors.must contain at least 1 number!' | translate }} </small>
    }
    @if (control?.errors?.hasCapitalCase) {
      <small> {{ name }} {{ 'formErrors.must contain at least 1 in Capital Case!' | translate }} </small>
    }
    @if (control?.errors?.hasNumber) {
      <small> {{ name }} {{ 'formErrors.must contain at least 1 Letter in Small Case!' | translate }} </small>
    }
    @if (control?.errors?.hasSpecialCharacters) {
      <small> {{ name }}{{ 'formErrors.must contain at least 1 Special Character!' | translate }} </small>
    }
    @if (control?.errors?.invalidDateFormat) {
      <small> {{ name }}{{ ' must be YYYY/MM/DD.!' | translate }} </small>
    }
    @if (control?.errors?.mustMatch) {
      <small> {{ name }} {{ 'formErrors.do not match.' | translate }} </small>
    }
    @if (control?.errors?.unique) {
      <small> {{ name }} {{ 'formErrors.must be unique.' | translate }} </small>
    }
    @if (control?.errors?.dispatched) {
      <small> {{ control?.errors?.dispatched }}</small>
    }
    @if (control?.errors?.minNumber) {
      <small> {{ name }}{{ 'formErrors.must be greater than 0.' | translate }} </small>
    }
    @if (control?.errors?.dateRange) {
      <small> {{ control?.errors?.dateRange }} </small>
    }
    @if (control?.errors?.amountRange) {
      <small> {{ control?.errors?.amountRange }} </small>
    }
    @if (control?.errors?.arrayNotEmpty) {
      <small>{{ 'You must select at least one ' | translate }} {{ name }} </small>
    }
    @if (control?.errors?.email) {
      <small>{{ name }} {{ 'formErrors.is invalid.' | translate }} </small>
    }
    @if (control?.errors?.uniqueDay) {
      <small>{{ name }} {{ 'formErrors.must be unique.' | translate }} </small>
    }
    @if (control?.errors?.uniqueField && !control?.errors?.required) {
      <small>{{ name }} {{ 'formErrors.must be unique.' | translate }} </small>
    }
    @if (control?.errors?.timeRangeInvalid) {
      <small>{{ name }} {{ 'formErrors.must be greater.' | translate }} </small>
    }
    @if (control?.errors?.dateRangeInvalid) {
      <small>{{ name }} {{ 'formErrors.must be after the start date.' | translate }} </small>
    }
    @if (control?.errors?.instructorUnavailable) {
      <small>{{ 'formErrors.Instructor is not available for the selected date and time..' | translate }} </small>
    }
    @if (control?.errors?.roomUnavailable) {
      <small>{{ 'formErrors.Room is not available for the selected date and time..' | translate }} </small>
    }
  </div>
}
